var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("p", { staticClass: "grey-text text-left text-darken-2" }, [
        _vm._v(
          "\n    " +
            _vm._s(_vm.$t("file.messages.selectApplicationToUpload.0")) +
            "\n  "
        ),
      ]),
      _vm._v(" "),
      _c(
        "material-input",
        [
          _c("select2", {
            attrs: {
              name: "application-selection",
              value: _vm.applicationId,
              data: _vm.computedApplications,
              options: _vm.applicationSelectOptions,
              "format-data": _vm.formatData,
            },
            on: { change: _vm.handleApplicationIdChange },
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }